import React, { useState, useEffect } from "react";
// import ReactDOM from "react-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import QuestListContent from "./QuestListContent";
import { Row, Col } from 'react-bootstrap';
import { useMappedState, useDispatch } from 'redux-react-hook';

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const grid = 8;

//draggable style
const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,
    border: `1px solid lightgray`,

    // change background colour if dragging
    background: isDragging ? "lightgreen" : "white",

    // styles we need to apply on draggables
    ...draggableStyle
});

//droppable style
const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "#f0f0f0" : "white",
    padding: grid,
    width: '100%'
});


export default function QuestList(props) {
    const tmpItems = useMappedState(state => state.tmpItems);
    const dispatch = useDispatch();

    function onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        // console.log(result);

        tmpItems.forEach((d, i) => {
            tmpItems[i].oldIndex = i + 1;
        })
        let tmp = reorder(
            tmpItems,
            result.source.index,
            result.destination.index
        );
        let oldIndexMap = {};
        tmp.forEach((d, i) => {
            oldIndexMap[d.oldIndex] = i + 1;
        })
        // console.log(oldIndexMap);
        tmp.forEach((d, i) => {
            // console.log("----", i, "----");
            let isJump = false;
            if (null != d
                && null != d.ru
                && null != d.ru.route
                && 0 != d.ru.route.ty
                && null != d.ru.route.ta) {
                // console.log(d.ru.route.ta, oldIndexMap);
                let minTarget = i + 2;
                let oldNext = d.oldIndex + 1;
                if (d.ru.route.pr) {
                    let newTarget = oldIndexMap[d.ru.route.pr];
                    console.log("old pr", d.ru.route.pr)
                    if (d.ru.route.pr == oldNext //原不跳題
                        //更新後跳題小於等於下題
                        || newTarget <= minTarget) d.ru.route.pr = minTarget;
                    else {
                        d.ru.route.pr = newTarget;
                    }
                    console.log("new pr", d.ru.route.pr)
                }
                d.ru.route.ta.forEach((dd, index) => {
                    let newTarget = oldIndexMap[dd];
                    // console.log("    ", index, dd, newTarget, oldNext, minTarget)

                    if (tmp[i].ru.route.ta[index] == oldNext //原不跳題
                        //更新後跳題小於等於下題
                        || newTarget <= minTarget) tmp[i].ru.route.ta[index] = minTarget;
                    else {
                        tmp[i].ru.route.ta[index] = newTarget;
                        isJump = true;
                    }
                })
                // console.log(isJump, d.ru.route.ta);
            }
            if (false == isJump) {
                // console.log("no jump, clean rule");
                tmp[i].ru.route = { ty: 0 };
            }
        })
        // console.log(oldIndexMap);

        // console.log(tmp);
        // setTmpItems(tmpItems);

        dispatch({ type: "UPDATE_TMP_ITEM", data: tmp });
    }

    function render() {
        if (null == tmpItems) {
            return <div>aa</div>
        }

        return (
            <DragDropContext className="row question-card" onDragEnd={onDragEnd}>
                <Droppable className="col" droppableId="droppable">
                    {(provided, snapshot) => (
                        <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={getListStyle(snapshot.isDraggingOver)}
                        >
                            {tmpItems.map((item, index) => (
                                <Draggable key={item.id} draggableId={item.id} index={index}>
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}

                                            style={getItemStyle(
                                                snapshot.isDragging,
                                                provided.draggableProps.style
                                            )}
                                        >
                                            <QuestListContent
                                                index={index}
                                                onTrash={() => { props.onRemove(index) }}
                                                onCopy={() => { props.onCopy(index) }}
                                                dragProrp={provided.dragHandleProps}
                                            ></QuestListContent>
                                        </div>
                                    )}
                                </Draggable>
                            ))}
                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>
        );
    }
    return render();
}
